export default __webpack_public_path__ + "static/media/pplight.7f2240d9.png";